class GaiaLightbox extends HTMLElement {
  constructor() {
    super();
    this.openerElement = null;
    // Close lightbox events
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.closeLightbox();
      }
    });
    document.querySelectorAll(".lightbox-close").forEach((element) => {
      element.addEventListener("click", () => {
        this.closeLightbox();
      });
    });

    // Listen for clicks in lightbox to activate zoom
    this.querySelectorAll("img").forEach((image) => {
      image.addEventListener("click", this.imageZoom.bind(this), {
        passive: true,
      });
    });
    // If slide changes, zoom out
    this.querySelectorAll(".swiper-button").forEach((button) => {
      button.addEventListener("click", () => {
        this.zoomOutAll();
        console.log("swiper button clicked");
        this.querySelectorAll(".video-container").forEach((videoContainer) => {
          videoContainer.style.opacity = "1";
          console.log("video container opacity set to 1 on", videoContainer);
        });
      });
    });
  }

  openLightbox(galleryId, slideIndex) {
    // Element that opened the lightbox
    this.openerElement = opener || document.activeElement;

    // Show lightbox
    this.style.display = "flex";

    console.log("Gallery ID:", galleryId);
    console.log("this:", this);

    this.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.style.opacity = "1";
    });

    // Log the selector being used
    const swiperContainer = this.querySelector(".swiper-container");
    console.log("Swiper container found:", swiperContainer);

    if (!swiperContainer.swiper) {
      // Reinit swiper
      new Swiper(swiperContainer, {
        loop: false,
        slidesPerView: 1,
        autoHeight: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });
      console.log("Swiper initialized on lightbox");
    }

    let swiperInstance = swiperContainer.swiper;
    console.log("Initial swiperInstance:", swiperInstance);

    if (swiperContainer && swiperContainer.swiper) {
      swiperInstance = swiperContainer.swiper;
      // console.log("Found swiper for galleryId:", galleryId, swiperInstance);
    } else {
      console.warn("Swiper container not found for galleryId:", galleryId);
    }

    // Slide to the clicked on slide
    setTimeout(() => {
      if (swiperInstance && typeof swiperInstance.slideTo === "function") {
        swiperInstance.slideTo(Number(slideIndex), 0);
        console.log("Slid to index after delay:", slideIndex);
      } else {
        console.warn("Swiper instance not found or not ready after delay!");
      }
    }, 100); //small delay to let swiper catch up

    document.body.classList.add("overflow-hidden");
    const focusableEls = this.querySelectorAll(
      ".lightbox-close, .swiper-button, [tabindex]:not([tabindex='-1'])"
    );
    if (focusableEls.length > 0) {
      focusableEls[0].focus();
    }

    // Add keydown listener for focus trapping
    document.addEventListener("keydown", this.focusLightbox.bind(this), {
      passive: false,
    });

    addFocusTrap(this);
  }

  closeLightbox() {
    this.style.display = "none";
    this.zoomOutAll();
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("keydown", this.focusLightbox.bind(this));
    // Focus onto element that opened the lightbox
    if (this.openerElement && typeof this.openerElement.focus === "function") {
      this.openerElement.focus();
    }
    this.openerElement = null;
  }

  imageZoom(e) {
    // Check if zoom is disabled
    if (
      e.target.classList.contains("zoom-disabled") ||
      e.target.classList.contains("video-poster")
    ) {
      return;
    }
    // Scale image by 2 (set in CSS)
    e.target.classList.toggle("zoomed-in");
    if (e.target.classList.contains("zoomed-in")) {
      this.setOrigin(e);
      e.target.addEventListener("mousemove", this.setOrigin.bind(this), {
        passive: true,
      });
    } else {
      e.target.removeEventListener("mousemove", this.setOrigin.bind(this));
    }
  }

  zoomOutAll() {
    // If clicked whilst zoomed in, zoom out
    this.querySelectorAll("img").forEach((image) => {
      image.classList.remove("zoomed-in");
    });
  }

  setOrigin(e) {
    // Allows for moving around image whilst zoomed in
    let rect = e.target.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;
    let w = rect.width;
    let h = rect.height;
    let left = Math.min(Math.max(Number(((x / w) * 100).toFixed(1)), 0), 100);
    let top = Math.min(Math.max(Number(((y / h) * 100).toFixed(1)), 0), 100);
    e.target.style.transformOrigin = `${left}% ${top}%`;
  }

  //   Accessibility controls
  focusLightbox(event) {
    var focusableEls = this.querySelectorAll(".lightbox-close, .swiper-button");
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];

    if (event.key === "Tab") {
      if (event.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    }
  }
}

function openLightbox(event, galleryId, slideIndex) {
  // t.preventDefault(), document.querySelector("gaia-lightbox").openLightbox(e);
  event.preventDefault();
  document.querySelector("gaia-lightbox").openLightbox(galleryId, slideIndex);
}

customElements.define("gaia-lightbox", GaiaLightbox);
